const Url = {
  // baseApiUrl: "http://localhost:3001",
  // baseApiUrl: "https://znkm0f852h.execute-api.ap-south-1.amazonaws.com/dev",
  // baseApiUrl: "https://v46z8c6kn5.execute-api.ap-south-1.amazonaws.com/testing",
  baseApiUrl: process.env.REACT_APP_LAMBDA_URL,
  pupilImportExcel: process.env.REACT_APP_PUPIL_IMPORT,
  // s3BucketUrl: "https://dev-beam-education-server.s3.ap-south-1.amazonaws.com/",
  s3BucketUrl: process.env.REACT_APP_S3_URL,
}

const apiRoutes = {
  // Common
  userLogin: "/v1/userLogin",
  user2FA: "/v1/twoFactorVerification",
  userRegister: "/v1/user_register",
  getNavBar: "/v1/fetchClass",
  fetchSubject: "/v1/fetchSubject",
  getOtp: "/v1/sendOtpForMail",

  // Profile
  getProfile: "v1/getProfile",
  updateProfile: "/v1/updateProfile",
  updatePassword: "v1/changePassword",

  //forgotPassword
  changePasswordByUserId: "/v1/changePasswordByUserId",

  //Classes
  fetchAllCategoryMark: "/v1/fetchAllCategoryMark",
  fetchPupilByClassId: "/v1/getPupilByClassId",
  fetchCategoryMark: "/v1/fetchCategoryMark",
  fetchDescriptionMark: "/v1/fetchDescriptionMark",
  fetchDescription: "/v1/fetchDescription",
  pupilCategoryUpdate: "/v1/pupilCategoryUpdate",
  pupilCategoryAttainment: "/v1/pupilCategoryAttainment",
  fetchMarksbyPupilUpn: "/v1/fetchMarksbyPupilUpn",
  getAssessmentByClassId: "/v1/getAssessmentsByClassId",
  getTeachersInClass: "/v1/fetchUserByClassId",
  getSignedUrls: "/v1/getSingedUrls",
  fetchgeneralComment: "/v1/fetchComments",
  updateStudentMarks: "/v1/pupilMarksUpdate",
  updategeneralComment: "/v1/insertComments",
  updateUserActivityRating: "/v1/updateUserActivityRating",
  uploadEvidence: "/v1/uploadEvidence",

  // SchoolAdmin
  adminPupil: "/v1/getPupil",
  adminClass: "/v1/getClasses",
  adminTeachers: "/v1/fetchUserByType",
  viewStudents: "/v1/fetchPupilByPresentClassId",
  getCurrentSchool: "v1/getSchool",
  getPupil: "/v1/getPupilById",
  getWondeStatus: "/v1/getWondeStatus",
  updatePupil: "/v1/editPupil",
  // updatePupil: "/v2/editPupil",
  deletePupil: "/v1/deletePupil",
  addClass: "/v1/saveClass",
  getAllAssignedStudents: "/v1/getAllAssignedStudents",
  getClassById: "/v1/getClass",
  getClassBySchoolId: "/v1/getClassBySchoolId",
  getUserById: "/v2/getUserById",
  renameClass: "/v1/updateClass",
  movePupil: "/v1/updatePupilClassId",
  // movePupil: "/v2/updatePupilClassId",
  deleteClass: "/v1/updateClassActiveStatus",
  assignRole: "/v1/updateUserType",
  updateUserActiveStatus: "/v1/updateUserActiveStatus",
  updateUserRole: "/v1/updateUserRole",
  // updateUserRole: "/v2/updateUserRole",
  removeType: "/v1/removeUserRoleById",
  inviteUser: "/v1/inviteUser",
  getSubjectByClass: "/v1/getSubjectByClass",
  getSubjectByClassId: "/v1/getSubjectByClassId",
  assignClass: "/v1/updateClassesbyUserId",
  removeClass: "/v1/removeClassesbyUserId",
  editInvite: "/v1/getInviteById",
  setPassword: "/v1/inviteUserPasswordUpdate",
  uploadURL: "/v1/getPupilBulkUploadUrl",
  pupilBulkUpdate: "/v1/pupilBulkUpdate",
  pupilsBulkUpload: "/v1/pupilBulkUpload", //v1
  // pupilsBulkUpload: "/v2/pupilBulkUpload",
  updateInvite: "/v1/updateInvite",
  revokeInvite: "/v1/deleteInvites",
  importFromWonde: "/v1/getPupilFromWonde",
  requestWondeSchoolAccess: "/v1/requestAccessFromSchool",

  //PupilProgress
  accordianData: "/v1/getMarksByPupilId",
  studentGraph: "/v1/getProgressByPupilId",
  assessment: {
    addEvidenceToAssessment: "/v1/updateEvidenceById",
    createAssessment: "/v1/createAssessment",
    deleteAssessmentById: "/v1/deleteAssessmentById",
    getPriorMarkings: "/v1/getKpiMarksByPupilId",
    getAssessmentById: "/v1/getAssessmentById",
    getEvidenceByClassId: "/v1/getEvidenceByClassId",
    updateEvidenceName: "v1/updateEvidenceName",
    fetchDescriptionCriteria: "/v1/fetchDescriptionByCategory",
    getKpiCategory: "/v1/getKpiCategory",
    updateMarkById: "/v1/updateMarkById",
    updateMarksByPupilId: "/v1/updateMarksByPupilId",
    pupilOutcomeCalculation: "/v1/pupilOutcomeCalculation"
  },
  fetchTargetForParticularSubjectAndYear: "/v1/fetchTargetForParticularSubjectAndYear",
  updateTargetForParticularSubjectAndYear: "/v1/updateTargetForParticularSubjectAndYear",
  displayTarget: "/v1/displayTarget",
  progressReports: {
    getReportsByPupilId: "/v1/getReportsByPupilId",
    getReportById: "/v1/getReportById",
    saveReport: "/v1/saveReport",
  },

  //Dashboard
  dashboard: {
    getPredictedOutcomebyClassId: "/v1/getPredictedOutcomebyClassId",
    getPredictedOutcomeBySchoolId: "/v1/getPredictedOutcomeBySchoolId",
    getPupilBySchoolId: "/v1/getPupilBySchoolId",
    getTotalDescriptionMarked: "/v1/getTotalDescriptionMarked",
    getOverallPredictedPassRate: "/v1/getOverallPredictedPassRate",
    getTeacherRating: "/v1/teacherRating",
    getTotalObjectivesMarked: "/v1/getTotalObjectivesMarked",
    activityRatingEvidenceUploaded: "/v1/activityRatingEvidenceUploaded",
    activityRatingWritingAssessment: "/v1/activityRatingWrittingAssessment",
  },
  //SuperAdmin
  superAdmin: {
    getAllSchools: "/v1/getAllSchools",
    getSchoolById: "/v1/getSchoolById",
    saveSchool: "/v1/saveSchool",
    inviteAdminUser: "/v1/inviteAdminUser"
  },
  bigPicture: {
    getClassByYear: "/v1/getClassByYear",
    getAllEOYP: "/v1/getEndOfYearPrediction",
    getCurriculumCoverage: "/v1/getCurriculumCoverage",
    getDemographics: "/v1/getDemographics",
    getDemographicsByPupilPremium: "/v1/getDemographicsByPupilPremium",
    getDemographicsByEAL: "/v1/getDemographicsByEAL",
    getDemographicsByGender: "/v1/getDemographicsByGender",
    getDemographicsByGld: "/v1/getDemographicsByGld",
    getDemographicsBySend: "/v1/getDemographicsBySend",
    getDemographicsByYear: "/v1/getDemographicsByYear",
    getProgress: "/v1/getProgress",
    getPredictedPassRateByYear: "/v1/getPredictedPassRateByYear",
  }

}

export { Url, apiRoutes };

